import React from 'react'
import "../Components/DeletePopup.scss"
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

const Updatepopup = ({ visible, onHide, onConfirm }) => {
    const footerContent = (
        <div className='popup-buttons'>
            <Button label="Cancel"  onClick={onHide}  className='addcancel-btn'/>
            <Button label="Update"  onClick={onConfirm} autoFocus className="updatepopup-btn"/>
        </div>
    );

    const headerContent = (
    <i className="pi pi-sync" style={{ color: '#05B8E6',padding:"25px",fontSize:"24px" }}></i>
    )


    return (
        
        <div className="card flex justify-content-center ">
            <Dialog header={headerContent} visible={visible} style={{ width:"400px",height:"300px" }} onHide={onHide} footer={footerContent} className="popup-dialogbox">
                <h2 className='popup-title'>Update Section</h2>
                
                <p className="popup-content">
                Are you sure you want to update this Section? This action cannot be undone.
                </p>
            </Dialog>
        </div>
    )
    
}

export default Updatepopup